import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateRegionStatus } from "../services/update-region-status";
import { toast } from "@/hooks/use-toast";

export function useUpdateRegionStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, is_active }: { id: string; is_active: boolean }) =>
      updateRegionStatus(id, is_active),
    onSuccess: () => {
      // Status change affects both the admin list and the active-regions toggle.
      queryClient.invalidateQueries({ queryKey: ["regions"] });
      toast({
        title: "Success",
        description: "Region status updated successfully",
      });
    },
    onError: (error) => {
      toast({
        title: "Error",
        description: error.message || "Failed to update region status",
        variant: "destructive",
      });
    },
  });
}
